import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { LoadMoreBtnComponent, SeoPaginationComponent } from '@web/shared/ui';
import { UniversitiesStore } from '../../data-access/+state/universities.store';
import { LoadMoreGTMService } from '@uc/web/core';

@Component({
	selector: 'uc-university-pagination',
	imports: [CommonModule, LoadMoreBtnComponent, SeoPaginationComponent],
	templateUrl: './university-pagination.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityPaginationComponent {
	readonly store = inject(UniversitiesStore);
	product = this.store.product;
	page = this.store.payload.page;
	searchTerm = this.store.payload.name;
	queryParams = this.store.queryParams;
	isLoading = this.store.isLoadingPagination;
	hasMorePages = this.store.universities()?.has_more_pages || false;

	constructor(
		private _location: Location,
		private _loadMoreGTMSrv: LoadMoreGTMService,
	) {}

	onLoadMore() {
		this.store.updateUniversitySearchPage(this.page() + 1);
		let path = this._location.path();

		if (path.match(/page=\d+/)) {
			path = path.replace(/page=\d+/, `page=${this.page()}`);
		} else {
			path += (path.includes('?') ? '&' : '?') + `page=${this.page()}`;
		}
		this._location.go(path);
		this._loadMoreGTMSrv.loadResults(this.searchTerm());
	}
}
